import React, { useState } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ApiActions } from '../shared/apiActions';
import apiCall from '../shared/apiCall';

export default function EmailVerificationTokenRequired({ currentUser, onShowContactModal }) {
  const { t } = useTranslation();
  const [isResending, setIsResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [resendError, setResendError] = useState('');

  const handleResendVerification = async () => {
    setIsResending(true);
    setResendMessage('');
    setResendError('');
    
    try {
      const response = await apiCall(
        `/api/set?action=${ApiActions.RESEND_VERIFICATION}`,
        {},
        'POST'
      );
      
      if (response.success) {
        setResendMessage(t('auth.emailVerification.emailSent'));
      } else {
        setResendError(response.message || t('auth.emailVerification.resendFailed'));
      }
    } catch (error) {
      console.error('Error resending verification email:', error);
      setResendError(t('auth.emailVerification.errorOccurred'));
    } finally {
      setIsResending(false);
    }
  };

  return (
    <>
      <div className="mb-3">
        <h5 className="mb-2">{t('auth.emailVerification.nextSteps')}</h5>
        <ol className="text-start mb-0">
          <li className="mb-1">{t('auth.emailVerification.step1')}</li>
          <li className="mb-1">{t('auth.emailVerification.step2')}</li>
          <li className="mb-1">{t('auth.emailVerification.step3')}</li>
        </ol>
      </div>

      {resendMessage && (
        <Alert variant="success" dismissible onClose={() => setResendMessage('')}>
          <i className="bi bi-check-circle-fill me-2"></i>
          {resendMessage}
        </Alert>
      )}

      {resendError && (
        <Alert variant="danger" dismissible onClose={() => setResendError('')}>
          {resendError}
        </Alert>
      )}

      <div className="d-grid gap-2 mb-3">
        <Button 
          variant="primary" 
          size="lg"
          onClick={handleResendVerification}
          disabled={isResending}
        >
          {isResending ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              {t('auth.emailVerification.sending')}
            </>
          ) : (
            <>
              <i className="bi bi-envelope me-2"></i>
              {t('auth.emailVerification.resendEmail')}
            </>
          )}
        </Button>
      </div>

      {/* Contact us section */}
      <hr className="my-3" />
      <p className="text-muted small mb-2">
        {t('auth.emailVerification.didntReceiveEmail')}
      </p>
      <Button 
        variant="outline-secondary"
        size="sm"
        onClick={onShowContactModal}
      >
        <i className="bi bi-chat-dots me-2"></i>
        {t('auth.emailVerification.contactUs')}
      </Button>
    </>
  );
}
